/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-bubble': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.75 18.75H2.5c-.69 0-1.25-.56-1.25-1.25V1.25H2.5V17.5h16.25v1.25zM6.25 10a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm0-1.25a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm6.875-5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-1.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm2.188 10.625a.937.937 0 110 1.875.937.937 0 010-1.875zm0-1.25a2.187 2.187 0 100 4.375 2.187 2.187 0 000-4.375z"/>'
  }
})
